// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"4e2fab71","898":"0d33b886"}[chunkId] + ".chunk.css";
};